import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  const height = theme.typography.pxToRem(44);
  const appIconSelectedColor = theme.evPalette.ocean['600'];

  return {
    headerContainer: {
      width: '100%',
      height: (props) => (props.show ? height : 0),
      opacity: (props) => (props.show ? 1 : 0),
      visibility: (props) => (props.show ? 'visible' : 'hidden'),
      boxShadow: `0 1px 15px 1px ${theme.evPalette.charcoal['500']}`,
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      justifyContent: 'space-between',
      zIndex: 1000,
      transition: `all .2s ${theme.transitions.easing.easeInOut}`,
    },
    evLogo: {
      padding: theme.spacing(1.5),
    },
    headerActionButtons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: theme.spacing(3),
    },
    notification: {
      marginRight: theme.spacing(1),
    },
    iconButtonClicked: {
      background: theme.evPalette.ocean['100'],
    },
    selectedIcon: {
      color: appIconSelectedColor,
    },
    helpIcon: {
      marginTop: theme.spacing(0.5),
      textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  };
});
